// A sent quotation (or proforma) must always carry a next follow-up until it
// moves on to a proforma, an order or an invoice (client, 2026-10-29). Same
// rule as the server's src/shared/sales/document-followup.js. Drafts are not
// sent yet; expired, accepted, invoiced, superseded and cancelled documents
// are no longer chased.

const CHASED_TYPES = ['quotation', 'proforma'];
const CHASED_STATUSES = ['quotation', 'proforma'];

export interface ChasedDoc {
  documentType?: string;
  status?: string;
  isExpired?: boolean;
}

export function isChased(doc: ChasedDoc | null | undefined): boolean {
  return Boolean(doc && CHASED_TYPES.includes(String(doc.documentType)) && CHASED_STATUSES.includes(String(doc.status)) && !doc.isExpired);
}

/**
 * True when the document is still being chased and has no open follow-up —
 * unless one was closed as "No next follow-up needed", with a reason (2026-10-30).
 */
export function needsNextFollowup(doc: ChasedDoc | null | undefined, followups: Array<{ status?: string; noNextReason?: string }>): boolean {
  return isChased(doc) && !followups.some((f) => f.status === 'open' || (f.noNextReason || '').trim());
}
